import DateFormat from '@/lib/Dates/DateFormat';
import momentFilter from '@/filters/moment';

/**
 * Display a Date object as a formatted string, where the date is the most important
 * thing to display:  Mon Jan 25th 2021
 * If the second parameter is true it also adds the time: Mon Jan 25th 2021 1:23 PM
 * See DateFormat.js for more info about the difference between dateFilter and timeFilter.
 *
 * @param {Date} date
 * @param {boolean} withTime
 *
 * @return {string}
 */
export const dateFilter = (date, withTime) => {
    return momentFilter(date, withTime ? DateFormat.DATE_WITH_TIME : DateFormat.DATE);
};
